import { useMutation } from "@tanstack/react-query";
import { editableTextUpdate } from "common/api/unos_rad/unos_editable_text";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosEditableTextUpdateParams = {
  invalidateKeys?: string[];
};

export const useUnosEditableTextUpdate = (
  hookParams?: UseUnosEditableTextUpdateParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: editableTextUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await editableTextUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { editableTextUpdateMutate };
};
